module.exports = __webpack_public_path__ + "media/images/common/project_active_right-b3dc4a4ca1dbd2d63e123d00bdfdb94b.png";